import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { CompaniesService } from '../companies.service';
import { ICompany } from '../companies.interface';
import { ICountry, ICountryFilter } from '../../../countries-page/countries/countries.interface';
import { ISubscription } from '../../../subscriptions-page/subscriptions/subscriptions.interface';
import { CountriesService } from '../../../countries-page/countries/countries.service';
import { SubscriptionsService } from '../../../subscriptions-page/subscriptions/subscriptions.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { SubscriptionsModalComponent } from '../../../subscriptions-page/subscriptions/subscriptions-modal/subscriptions-modal.component';

let self: any;

@Component({
  selector: 'app-companies-modal',
  templateUrl: './companies-modal.component.html',
  styleUrls: ['./companies-modal.component.css']
})
export class CompaniesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  editLogo: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  company!: ICompany;
  form!: UntypedFormGroup;
  submitted = false;
  countries: ICountry[] = [];
  isDev!: boolean;
  subscription!: ISubscription;
  toBilling = false;
  uploading = false;

  constructor(
    private _CompaniesService: CompaniesService,
    private _CountriesService: CountriesService,
    private _SubscriptionsService: SubscriptionsService,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    let countryFilter: ICountryFilter = {
      filters: { isDeleted: false },
      skip: 0,
      limit: 10000,
      sort: 'name'
    };
    this._CountriesService.getCountries(countryFilter).subscribe((countries) => {
      this.countries = countries;
      if (this.company._id) {
        this.getCompany();
        this.getSubscription();
      }
      else this.buildForm();
    });
    if (this.editLogo) this.readOnly = false;
  }

  getCompany() {
    this.loading = true;
    this._CompaniesService.getCompany(this.company._id || '').subscribe((company) => {
      this.company = company;
      this.buildForm();
      this.loading = false;
    });
  }

  getSubscription() {
    this.loading = true;
    this._SubscriptionsService.getSubscriptions({ filters: { company: this.company._id } }).subscribe(subscriptions => {
      this.subscription = _.first(subscriptions);
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.company.name, [Validators.required]],
      country: [_.get(this.company, 'country._id'), [Validators.required]],
      address: [this.company.address, [Validators.required]],
      email: [this.company.email, [Validators.required]],
      phone: [this.company.phone, [Validators.required]],
      taxId: [this.company.taxId],
      //taxAddress: [this.company.taxAddress]
      logo: [],
      isDeleted: [this.company.isDeleted]
    }, {
      validators: [
        toBillingValidator(this.toBilling),
      ]
    })

    if (this.company._id) this.form.markAllAsTouched();
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ICompany = _.cloneDeep(this.form.value);
    if (!data.logo) {
      delete data.logo
    }
    if (this.editLogo) {
      // nothing else to update
    } else {
      if (this.form.invalid) return;
    }

    this.saving = true;

    if (this.company._id) {
      data._id = this.company._id;
      this._CompaniesService.updateCompany(data).subscribe((company) => {
        this.dialog.close(company);
      });
    } else {
      this._CompaniesService.createCompany(data).subscribe((company) => {
        this.dialog.close(company);
      });
    }
  }

  openSubscriptionModal() {
    let config = new MatDialogConfig();
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(SubscriptionsModalComponent, config);
    self.dialogRef.componentInstance.subscription = this.subscription || { company: this.company, features: [] }
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.subscription = result;
    });
  }

  imagesOnChanging() {
    this.uploading = true;
  }

  imagesOnChange(data: any) {
    this.uploading = false;
    if (data && data.files) {
      // this.company.logo.fileUrl = ""
      this.form.controls['logo'].setValue(data.files.map((el: any) => el._id)[0]);
    }
  }
}

function toBillingValidator(toBilling: boolean) {
  return (group: UntypedFormGroup) => {
    let nameControl = group.controls['name'];
    let taxIdControl = group.controls['taxId'];
    let emailControl = group.controls['email'];
    let phoneControl = group.controls['phone'];
    let errors = {};
    // console.log(nitControl.value)
    // console.log(taxAddressControl.value)

    if (toBilling) {
      if (!nameControl.value) { errors = { ...errors, nameBillingRequired: true }; }
      if (!taxIdControl.value) { errors = { ...errors, taxIdBillingRequired: true }; }
      if (!emailControl.value) { errors = { ...errors, emailBillingRequired: true }; }
      if (!phoneControl.value) { errors = { ...errors, phoneBillingRequired: true }; }
    }

    if (Object.keys(errors).length === 0) {
      nameControl.setErrors(null);
      taxIdControl.setErrors(null);
      emailControl.setErrors(null);
      phoneControl.setErrors(null);
    } else {
      //console.log("errores ttt ", errors)
      nameControl.setErrors(errors);
      taxIdControl.setErrors(errors);
      emailControl.setErrors(errors);
      phoneControl.setErrors(errors);
    }
  }
}